export default __webpack_public_path__ + "static/media/pencil.5011c2eb.svg";